<template lang="html">
  <div>
    <event-groups-item
      v-model="selectedItemId"
      :clone-id="cloneId"
      :base-event-id="baseEventId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import EventGroupsItem from './EventGroupsItem'

export default {
  name: 'EventGroupsList',
  components: {EventGroupsItem},
  mixins: [itemSelect],
  props: {
    baseEventId: [Number, String, Object]
  },
  data: function () {
    return {
      type: 'Recurrence Group',
      types: 'Recurrence Group',
      headers: [
        this.headerText('Recurrence Group Name', 'name', true),
        this.headerText('Comments', 'notes', true)
      ],
      apiRecordCommand: 'diningEventGroup'
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  }
}
</script>
<style>
</style>
